module.exports = __webpack_public_path__ + "assets/img/noData.b703443a.png";